$(".scent-sectionmainslider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_2.svg?v=1738043059"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_1.svg?v=1738043059"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});



$(".brandslide-sec").slick({
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  pauseOnHover: false,
  cssEase: "linear",
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$windowWidth = $(window).width();

if ($windowWidth <= 767) {
$(".unlock-boxslider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1, 
  autoplaySpeed: 1500,
  autoplay: true, 
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_2.svg?v=1738043059"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_1.svg?v=1738043059"></div>', 
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});


$(".how-to-layer").slick({
  dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1, 
  autoplaySpeed: 1500, 
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_2.svg?v=1738043059"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_1.svg?v=1738043059"></div>'
});


$(".recipeaddtocart-sectioninner").slick({
  dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1, 
  autoplaySpeed: 1500, 
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_2.svg?v=1738043059"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_1.svg?v=1738043059"></div>'
}); 

  
}


// $(".tabing-slidersecmain").slick({
//   dots: false,
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1, 
//   autoplay: true,
//   infinite: true,
//   autoplaySpeed: 3500,
//   prevArrow: '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Vector_9_1.png?v=1739454346"></div>',
//   nextArrow: '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Vector_9_2.png?v=1739454346"></div>', 
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },

//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ],
// });


$(".slider-scentsec").slick({
  dots: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 1500,
  autoplay: true, 
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_2.svg?v=1738043059"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Icon_1.svg?v=1738043059"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});